<template>
  

     <!-- SIDE BAR SECTION -->
     <div class="fixed z-40">
        <adminSideBar/>
    </div>

 <!-- NAV BAR SECTION -->
    <nav class="sticky w-full z-20 top-0 " >
        
        <adminNavBar/>

    </nav>

<!-- DASHBOARD -->

<div class="flex bg-medalertBlue bg-opacity-10 w-full h-full pb-12">
    
   

    <div class="mt-3 w-full ml-64 font-euclid mr-8">

        <div class=" flex w-full rounded-md justify-between">

            <h2 class=" text-black font-semibold text-left ">SMS Unit</h2>

            <div  class="">
                <button @click="togglemakePaymentModal" class="text-white bg-medalertBlue hover:bg-blueHover font-medium py-1 px-3 rounded-md"> Make Payment </button>
            </div>

        </div>

        <div class="flex justify-between">

            <div  class="my-6 flex bg-white py-8 px-5 w-full rounded-md">
               <h1>Total Units Left: <span class="px-3 text-xl font-medium text-medalertBlue">{{clientDetails.units_remaining}}</span></h1>
            </div>
           
        </div>

        <div > 
            <div class="flex justify-between">
                <h2 class=" text-black font-semibold text-left ">Company</h2>

                <div v-if="!checkVerify" class=" flex">
                    <button @click="verifyClient" class="text-white bg-medalertBlue font-medium py-1 px-3 rounded-md hover:bg-medalertOrange"> Verify Client </button>
                </div>

                <div v-else class=" flex">
                    <button @click="unverifyClient" class="text-white bg-medalertOrange font-medium py-1 px-3 rounded-md hover:bg-medalertBlue"> Revoke Access </button>
                </div>

            </div>
             

            <div class="mt-5 bg-white py-4 rounded-md">
                <div class="flex w-full text-start px-5 py-3">
                <p class="text-black w-1/3">Name:</p>
                <p class=" w-2/3 items-start text-medalertBlue font-medium">{{clientDetails.name}}</p>
                </div>
                <div class="flex w-full text-start px-5 py-3">
                <p class="text-black w-1/3">Type:</p>
                <p class=" w-2/3 items-start text-medalertBlue font-medium">{{clientDetails.type}}</p>
                </div>
                <div class="flex w-full text-start px-5 py-3">
                <p class="text-black w-1/3">CAC Registration No:</p>
                <p class=" w-2/3 items-start text-medalertBlue font-medium">{{clientDetails.cac_registration_number}}</p>
                </div>
                <div class="flex w-full text-start px-5 py-3">
                <p class="text-black w-1/3">Verification:</p>
                <p class=" w-2/3 items-start text-medalertBlue font-medium">{{clientDetails.is_verified}}</p>
                </div>

            </div>
        </div>
        

        <div class="mt-8"> 
            <h2 class=" w-full py-3 text-black text-left font-semibold">Accounts(s)</h2> 

            <div class="h-auto  w-full bg-white rounded-md">
                        <table class="table w-full text-left mx-auto rounded-md table-auto">
                            <thead class="bg-gray-100 py-2 font-light rounded-md">
                                <tr class="text-gray-700 text-sm" >
                                    <th class="px-2 py-2">Administrator</th>
                                    <th class="px-2 py-2">Phone Number</th>
                                    <th class="px-2 py-2">Email</th>
                                    <th class="px-2 py-2">Company's Address</th>
                                    <th class="px-2 py-2">City</th>
                                    <th class="px-2 py-2">State</th>
                                    <th class="px-2 py-2">Country</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(account, index) in clientDetails.accounts" :key="index">
                                    <td class="px-2 py-1">{{account.first_name}}</td>
                                    <td class="px-2 py-1">{{account.phone_number}}</td>
                                    <td class="px-2 py-1">{{account.email}}</td>
                                    <td class="px-2 py-1">{{account.address.street_address}}</td>
                                    <td class="px-2 py-1">{{account.address.city}}</td>
                                    <td class="px-2 py-1">{{account.address.state}}</td>
                                    <td class="px-2 py-1">{{account.address.country}}</td>
                                </tr> 
                                
                            </tbody>
                        </table>
    
                    </div>
        </div>

        <div class="overflow-auto" v-show="makePaymentModal " >
            <Modal :modalActive="makePaymentModal" class="relative" @close="togglemakePaymentModal">
                <div class="close-icon absolute sm:top-15 lg:top-5 right-5 w-8 h-8 cursor-pointer hover:border-gray">
                    <svg
                    @click="togglemakePaymentModal"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    >
                    <line
                        x1="15"
                        y1="15"
                        x2="25"
                        y2="25"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                    />
                    <line
                        x1="25"
                        y1="15"
                        x2="15"
                        y2="25"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                    />
                    <circle
                        class="circle"
                        cx="20"
                        cy="20"
                        r="19"
                        opacity="0"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        fill="none"
                    />
                    <path
                        d="M20 1c10.45 0 19 8.55 19 19s-8.55 19-19 19-19-8.55-19-19 8.55-19 19-19z"
                        class="progress"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        fill="none"
                    />
                    </svg>
                </div>

                <div
                v-if="success"
                class=" border w-full  mx-auto bg-medalertBlue bg-opacity-10  text-black px-4 py-3 my-6 rounded relative"
                role="alert">

                    <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
                    <span class="">{{ success }}</span>
                </div>

                <div
                v-if="err"
                class=" border w-full  mx-auto bg-red  text-white px-4 py-3 my-6 rounded relative"
                role="alert">

                    <span class="">{{ err }}</span>
                </div>

                <h1 class="border-b-2 text-left border-gray-light px-2 md:px-5 text-lg pb-1">Pay into Account</h1>

                <div class="mx-auto bg-[#f1f3f8] pt-4"> 

                    <form @submit.prevent="handleMakePayment" action="" class="px-6 pb-8">


                        <div class="flex mt-2 flex-col text-sm font-semibold">
                                <div class=" w-full text-left  flex justify-between">
                                    <div class="flex flex-col w-5/12">
                                        <h1 class="mb-2">Amount (Naira)</h1>
                                        <div class="bg-gray-200 text-left rounded-md border-2 ">
                                            <input v-model="amount" class="text-black w-full p-1.5" required type="number">
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>

                        <div class="flex-col text-sm font-semibold">

                            <div class="mt-6 flex justify-start">
                                <button 
                                @click.prevent="handleMakePayment"
                                :disabled="inactive"
                                :class="inactive ? 'cursor-not-allowed' : ''" 
                                 class="py-2 px-10 disabled:bg-gray-200 bg-medalertBlue text-white rounded-md hover:bg-blueHover">
                                     Pay Now
                                </button>
                            </div>

                        </div>  

                    </form>

                </div>

            </Modal>
         </div>
                

    </div>

</div>



</template>

<script>

    import adminNavBar from '../components/AdminNavBar'
    import adminSideBar from '../components/AdminSideBar'
    import axios from 'axios';
    
    import { ref } from 'vue'
    import { useRoute } from "vue-router";
    import {useRouter} from 'vue-router'
    import { useStore } from "vuex";
    import Modal from "../components/Modal.vue";

export default {

    components:{adminNavBar,
         adminSideBar, 
         Modal},

    setup(){

        const route = useRoute();
        const router = useRouter();
        const makePaymentModal = ref(false);
        const amount = ref();
        const inactive = ref(false);

        const clientDetails = ref({})
        const checkVerify = ref('')
        const success = ref("");
        const err = ref("");
        const clientId = route.params.id
    
        const getClientDetails = async () =>{
        try{
            const response = await axios.get(`/api/v1/clients/${clientId}`)
            let clientData = response.data.data
            console.log(clientData)
            clientDetails.value = clientData
            checkVerify.value = clientData.is_verified
        } catch(error){
            err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch all client";
        }
        }

        
        const verifyClient = async () => {
        try{
          const clientId = route.params.id
          const response = await axios.put(`/api/v1/clients/${clientId}/verify`);
          if (response){
            console.log(response)
            let feedback =  response.data.result.message
            alert(feedback)
            // router.push('/clients');
          } else {
                throw new Error('could not verify client')
            }
            getClientDetails()
        } catch(error){
        err.value = error.response?.result?.message ?? "Erorr! verify client unsuccessful";}
        };


        const unverifyClient = async () => {
        try{
          const clientId = route.params.id
          const response = await axios.put(`/api/v1/clients/${clientId}/unverify`);
          if (response){
            console.log(response)
            let feedback =  response.data.result.message
            alert(feedback)
          } else {
                throw new Error('could not revoke client access')
            }
            getClientDetails()
        } catch(error){
        err.value = error.response?.result?.message ?? "Erorr! revoke client access unsuccessful";}
        };

        const togglemakePaymentModal = () => {
            makePaymentModal.value = !makePaymentModal.value;
        };

        const handleMakePayment = async () =>{
            try{
                inactive.value = true
                const response = await axios.post('/api/v1/payments/buy-unit', {
                    "amount": amount.value,
                    "client_id": route.params.id
                }) 
                if(response){
                    console.log(response)
                    let purchasedUnit = response.data.data.sms_unit
                    let feedback =  response.data.result.message
                    success.value = feedback + 'Units Purchased: ' + purchasedUnit
                }

                amount.value = "";
                inactive.value = false
                
                setTimeout(() => {
                success.value = "";
                makePaymentModal.value = false
                }, 3000); 
                getClientDetails()

               
                
            } catch(error){
                console.log(error)
                err.value = error
                setTimeout(() => {
                err.value = "";
                }, 3000);

            }

        }




        return{
            getClientDetails,
            clientDetails,
            checkVerify,
            err,
            success,
            makePaymentModal,
            amount,
            inactive,
            verifyClient,
            unverifyClient,
            togglemakePaymentModal,
            handleMakePayment
        }

    },

    mounted(){
          this.getClientDetails();
        }

}
</script>

<style>

</style>